export default __webpack_public_path__ + "static/media/pokeball-animation.dc18ea15.gif";